import store from "../../../../../store";
import { AbstractSource } from "../../../../base/infrastructure/drawing";
import { IContentSource } from "../../../../base/domain/drawing";
import { ImageSourceKinds, IDocumentImageSource } from "../../../../documaker/domain/document";
import { IConfiguration } from "../../configuration";

export class EditableFormatImageSource extends AbstractSource implements IDocumentImageSource {
  constructor(
    getToken: () => string,
    public formatId: number,
    public documentId: number,
    private _imageSourceKind: ImageSourceKinds,
    public imageGuid: string,
    public quotedFormatid?: number
  ) {
    super(getToken);
  }

  public get imageSourceKind(): ImageSourceKinds {
    return this._imageSourceKind;
  }

  public set imageSourceKind(kind: ImageSourceKinds) {
    this._imageSourceKind = kind;
  }

  protected getSource(): string {
    const config = store.getters.configuration as IConfiguration;
    if (this.formatId === null || this.formatId === undefined) {
      console.error(config.wording.format.attributes.name + "の画像の読み込みに失敗しました。formatId: " + this.formatId);
      return "InvalidUrl";
    }
    const url = this.imageGuid
      ? "/api/format-editor/format/" + this.formatId + "/image/" + this.imageGuid + "?token=" + this.token
      : "";
    console.debug("[Source] " + url);
    return url;
  }

  public clone(): IContentSource {
    return new EditableFormatImageSource(
      this._getToken,
      this.formatId,
      this.documentId,
      this.imageSourceKind,
      this.imageGuid,
      this.quotedFormatid
    );
  }
}
